import { css } from '@emotion/css';
import { Color, Display, ScreenBreakpoint, SpaceSize, Spacing } from 'src/styles';

export const progressBarContainer = css`
  ${Spacing.mlAuto}
  ${Spacing.mr24}
  ${Spacing.mt20}
  ${Spacing.mb40}
  color: ${Color.Brand6} !important;

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.mx0}
    ${Spacing.px16}
    ${Spacing.mb16}
  }
`;

export const stepsContaienr = css`
  ${Display.flex}
`;

export const step = ({ isComplete }: { isComplete: boolean }) => css`
  width: 25%;
  height: ${SpaceSize.is4};
  ${Spacing.mr4}
  background-color: ${isComplete ? Color.Green6 : Color.Brand1};
`;
